/*
  Create Your Piece — crest path (10.06b).
  A theme cannot carry a file through a URL, so the builder collects the
  choice — upload it on the product page next, or send it later — and the
  product page takes the upload. Nothing is uploaded here.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  CYP.use(function (cyp) {
    var panel = cyp.root.querySelector('[data-pb-step="4b"][data-pb-kind="crest"]');
    if (!panel) return;
    var next = panel.querySelector('[data-crest-next]');
    var reason = panel.querySelector('[data-crest-reason]');
    var note = panel.querySelector('[data-crest-note]');

    function render() {
      var s = cyp.state;
      panel.querySelectorAll('[data-crest]').forEach(function (opt) {
        var input = opt.querySelector('input');
        input.checked = input.value === s.crest;
        opt.classList.toggle('is-selected', input.checked);
      });
      next.setAttribute('aria-disabled', s.crest ? 'false' : 'true');
      if (note) {
        var prices = cyp.optionPrices();
        var price = prices ? (prices.crest ? '+' + cyp.money(prices.crest) : 'included') : (cyp.settings.fallback_crest || '');
        note.textContent = (price ? 'Crest ' + price + '. ' : '') + 'Choosing a crest clears any text, and the builder says so first.';
      }
      reason.textContent = s.crest ? '' : 'Choose how we get your crest to continue.';
    }

    function commit() {
      var s = cyp.state;
      if (!s.crest) {
        var first = panel.querySelector('input[name="pb-crest"]');
        if (first) first.focus();
        return;
      }
      cyp.emit('crest', { status: s.crest === 'later' ? 'send-later' : 'upload-on-product-page' });
      cyp.track('personalization_completed', { personalization_type: 'crest', crest: s.crest, value_length: 0, font: null });
      cyp.go('5');
    }

    panel.addEventListener('change', function (e) {
      if (e.target.name === 'pb-crest') cyp.set({ crest: e.target.value });
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.name === 'pb-crest') { e.preventDefault(); commit(); }
    });
    next.addEventListener('click', commit);

    cyp.on('state', render);
  });
})();
